export const REGISTRATION_LINK = 'https://interswap-refund.occam.fi/'
export const TG_LINK = 'https://t.me/occamfi_com/211980'
export const MEDIUM_LINK =
  'https://medium.com/occam-finance/a-farewell-from-occam-723c06b8daaf'
export const ANNOUNCEMENT_LINK =
  'https://medium.com/occam-finance/a-farewell-from-occam-723c06b8daaf'
export const CHAKRA_LINK = 'https://chakra-rewards.occam.fi/'
